<template>
  <div v-if="assetComponent">
    <div class="mb-4">
      <CreateOrChooseAssetSmallWidget
        :availableAssetIds="availableAssetIds"
        :currentAssetId="assetComponent.assetId"
        :isEdit="true"
        @selectedAssetId="setSelectedAsset"/>
    </div>
    <AssetComponentWithoutStore
      :isEvent="true"
      :contract="currentContract"
      :assetComponent="assetComponent"
      :unitsOfMeasure="unitsOfMeasure"
      :validationErrors="validationErrors"/>
  </div>
</template>

<script>
import AssetComponentWithoutStore from "../../../assetComponent/components/AssetComponentWithoutStore";
import {mapGetters} from "vuex";
import AssetComponent from "../../../assetComponent/models/AssetComponent";
import AddAssetComponent from "../../models/commands/AddAssetComponent";
import dateConverter from "../../../../utils/converters/date.converter";
import CreateOrChooseAssetSmallWidget from "../../../../components/widgets/CreateOrChooseAssetSmallWidget";
import AddLessorComponentShare from '../../models/commands/AddLessorComponentShare';

export default {
  components: {
    AssetComponentWithoutStore,
    CreateOrChooseAssetSmallWidget
  },
  props: {
    assetId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      assetComponent: null,
      validationErrors: [],
    };
  },
  mounted() {
    this.init();
  },
  computed:{
    ...mapGetters(["getCurrentContract"]),
    ...mapGetters(["getUnitOfMeasure"]),
    ...mapGetters(['getAssets']),
    availableAssetIds() {
      return this.getAssets;
    },
    unitsOfMeasure() {
      return this.getUnitOfMeasure;
    },
    currentContract() {
      return this.getCurrentContract;
    },
  },
  methods: {
    cancel() {
      this.init();
    },
    init() {
      this.assetComponent = new AssetComponent.createNew();
      this.assetComponent.assetId = this.assetId;
    },
    setSelectedAsset(assetIdInfoObject) {
      this.assetComponent.assetId = assetIdInfoObject.currentAssetId;
    },
    save() {
      if (this.assetComponent == null)
        throw new Error("assetComponent cannot be null");

      if (!this.validate()) return false;

      this.$eventBus.$emit('addAssetComponent', this.assetComponent);

      const startDateAsDate = dateConverter.convertToDate(this.assetComponent.startDate);
      const endDateAsDate = dateConverter.convertToDate(this.assetComponent.endDate);

      const transformedAssetComponent = {
        id: this.assetComponent.idInDB,
        assetId: this.assetComponent.assetId,
        name: this.assetComponent.name,
        externalId: this.assetComponent.externalId,
        unitOfMeasureCode: this.assetComponent.unitOfMeasureCode,
        quantity: this.assetComponent.quantity,
        startDateDay: this.$moment(startDateAsDate).format('DD'),
        startDateMonth: this.$moment(startDateAsDate).format('MM'),
        startDateYear: this.$moment(startDateAsDate).format('YYYY'),
        endDateDay: this.$moment(endDateAsDate).format('DD'),
        endDateMonth: this.$moment(endDateAsDate).format('MM'),
        endDateYear: this.$moment(endDateAsDate).format('YYYY'),
        endDateInitial: this.assetComponent.endDateInitial,
        endDateCommentary: this.assetComponent.endDateCommentary,
        extension: this.assetComponent.extension,
        termination: this.assetComponent.termination,
        buyout: this.assetComponent.buyout,
        isBuyout: this.assetComponent.isBuyout,
        paymentsParameters: this.assetComponent.paymentsParameters,
        manualChartPayments: this.assetComponent.manualChartPayments,
        devaluations: this.assetComponent.devaluations,
        expenses: this.assetComponent.expenses,
        isPermanent: this.assetComponent.isPermanent,
        lessorComponentShares: this.assetComponent.lessorComponentShares
      }

      const command = new AddAssetComponent(transformedAssetComponent)
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command)

      transformedAssetComponent.lessorComponentShares.forEach(lessorComponentShare => {
        const command = new AddLessorComponentShare(
          lessorComponentShare.idInDB,
          lessorComponentShare.externalId,
          transformedAssetComponent.id,
          lessorComponentShare.lessorId,
          transformedAssetComponent.startDateDay,
          transformedAssetComponent.startDateMonth,
          transformedAssetComponent.startDateYear,
          transformedAssetComponent.endDateDay,
          transformedAssetComponent.endDateMonth,
          transformedAssetComponent.endDateYear,
        )

        this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      })

      return true;
    },
    validate() {
      this.validationErrors = [];
      let assetComponent = _.cloneDeep (this.assetComponent);
      if (!assetComponent.startDate) {
        this.validationErrors.push("startDate");
      }
      if (!assetComponent.endDate) {
        this.validationErrors.push("endDate");
      }
      if (!assetComponent.quantity) {
        this.validationErrors.push("quantity");
      }
      if (!assetComponent.unitOfMeasureCode) {
        this.validationErrors.push("unitOfMeasureCode");
      }

      return this.validationErrors.length <= 0;
    }
  }
};
</script>

<style>
</style>
